import { useServicesMutation, useQueryClient } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useCopilotActions() {
  const queryClient = useQueryClient();
  const auth = useAuth();

  const deleteMutation = useServicesMutation('deleteCopilotSession', {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCopilotSessions'] });
    },
  });

  const updateMutation = useServicesMutation('updateCopilotSession', {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCopilotSessions'] });
    },
  });

  return {
    deleteSession: async (sessionId: number) => {
      await deleteMutation.mutateAsync({
        params: { accountId: auth.account.id, sessionId },
      });
    },
    renameSession: async (sessionId: number, name: string) => {
      await updateMutation.mutateAsync({
        params: { accountId: auth.account.id, sessionId },
        body: { name },
      });
    },
  };
}
